import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Alert, Table, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderPlus, faFolder, faEdit, faTrash, faSpinner, faSearch } from '@fortawesome/free-solid-svg-icons';
// import { toast } from 'react-toastify';
import { projectsAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

const ProjectsList = () => {
  const { currentUser } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    setLoading(true);
    setError('');
    



    
    try {
      // Use the projectsAPI from the centralized API service

      const response = await projectsAPI.getProjects();

      
      if (response.data.status === 200) {

        setProjects(response.data.data.projects || []);
      } else {
        console.error('API returned non-200 status:', response.data);
        setError('Failed to load projects');
      }
    } catch (err) {
      console.error('Error fetching projects:', err);
      console.error('Error details:', err.response ? err.response.data : 'No response data');
      setError('Failed to load projects. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (project) => {
    setProjectToDelete(project);
    setShowDeleteModal(true);
  };

  // const handleAnalyzeFile = (projectId, fileName) => {
  //   if (analyzing) return;
  //   setAnalyzing(true);
    
  //   // Show initial toast notification with enhanced styling
  //   const toastId = toast.info(
  //     <div className="d-flex align-items-center">
  //       <div className="spinner-border spinner-border-sm text-info me-2" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //       <div>
  //         <strong className="text-primary">Step 1/4:</strong> Fetching data from document...
  //       </div>
  //     </div>, 
  //     {
  //       autoClose: false,
  //       position: 'top-right',
  //       className: 'toast-with-progress',
  //       progressClassName: 'progress-bar-animated progress-bar-striped bg-info',
  //       icon: '🔍'
  //     }
  //   );
    
  //   // Update toast after a delay to simulate progress
  //   setTimeout(() => {
  //     toast.update(toastId, {
  //       render: (
  //         <div className="d-flex align-items-center">
  //           <div className="spinner-grow spinner-grow-sm text-warning me-2" role="status">
  //             <span className="visually-hidden">Loading...</span>
  //           </div>
  //           <div>
  //             <strong className="text-warning">Step 2/4:</strong> Analyzing document content...
  //           </div>
  //         </div>
  //       ),
  //       autoClose: false,
  //       className: 'toast-with-progress',
  //       progressClassName: 'progress-bar-animated progress-bar-striped bg-warning',
  //       icon: '📄'
  //     });
  //   }, 1500);
    
  //   // Update toast again to show more progress
  //   setTimeout(() => {
  //     toast.update(toastId, {
  //       render: (
  //         <div className="d-flex align-items-center">
  //           <div className="spinner-border spinner-border-sm text-primary me-2" 
  //                style={{borderWidth: '3px'}} role="status">
  //             <span className="visually-hidden">Loading...</span>
  //           </div>
  //           <div>
  //             <strong className="text-primary">Step 3/4:</strong> Generating AI insights...
  //           </div>
  //         </div>
  //       ),
  //       autoClose: false,
  //       className: 'toast-with-progress',
  //       progressClassName: 'progress-bar-animated progress-bar-striped bg-primary',
  //       icon: '🤖'
  //     });
  //   }, 3000);
    
  //   // Final delay before completing
  //   setTimeout(() => {
  //     toast.update(toastId, {
  //       render: (
  //         <div className="d-flex align-items-center">
  //           <div className="me-2">
  //             <FontAwesomeIcon icon={faCheckCircle} className="text-success" style={{fontSize: '1.2rem'}} />
  //           </div>
  //           <div>
  //             <strong className="text-success">Step 4/4:</strong> Analysis complete!
  //             <div className="small">Document insights are ready to view</div>
  //           </div>
  //         </div>
  //       ),
  //       type: 'success',
  //       autoClose: 5000,
  //       className: 'toast-success-custom',
  //       progressClassName: 'bg-success',
  //       icon: '✅'
  //     });
      
  //     setAnalyzing(false);
  //   }, 4500);
  // };

  const handleDeleteConfirm = async () => {
    if (!projectToDelete) return;
    
    setDeleteLoading(true);
    
    try {
      // Use the projectsAPI from the centralized API service
      const response = await projectsAPI.deleteProject(projectToDelete.id);
      
      if (response.data.status === 200) {
        // Remove deleted project from state
        setProjects(projects.filter(p => p.id !== projectToDelete.id));
        setShowDeleteModal(false);
      } else {
        setError('Failed to delete project');
      }
    } catch (err) {
      console.error('Error deleting project:', err);
      setError('Failed to delete project. Please try again later.');
    } finally {
      setDeleteLoading(false);
    }
  };

  // Filter projects based on search term
  const filteredProjects = projects.filter(project => 
    project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    project.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <Container className="text-center py-5">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="text-primary mb-3" />
        <h3>Loading projects...</h3>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <Row className="mb-4">
        <Col>
          <h1 className="mb-3">Projects</h1>
          
          {error && <Alert variant="danger">{error}</Alert>}
        </Col>
      </Row>
      
      <Row className="mb-4">
        <Col md={6}>
          <Form.Group className="mb-3">
            <div className="input-group">
              <span className="input-group-text">
                <FontAwesomeIcon icon={faSearch} />
              </span>
              <Form.Control
                type="text"
                placeholder="Search projects..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </Form.Group>
        </Col>
        <Col md={6} className="text-md-end">
          <Button as={Link} to="/projects/create" variant="primary">
            <FontAwesomeIcon icon={faFolderPlus} className="me-2" />
            Create New Project
          </Button>
        </Col>
      </Row>
      
      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              {projects.length === 0 ? (
                <div className="text-center py-5">
                  <FontAwesomeIcon icon={faFolder} size="3x" className="text-muted mb-3" />
                  <h4>No projects found</h4>
                  <p>Get started by creating your first project</p>
                  <Button as={Link} to="/projects/create" variant="primary">
                    <FontAwesomeIcon icon={faFolderPlus} className="me-2" />
                    Create New Project
                  </Button>
                </div>
              ) : filteredProjects.length === 0 ? (
                <div className="text-center py-5">
                  <h4>No projects match your search</h4>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Documents</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProjects.map(project => (
                      <tr key={project.id}>
                        <td>
                          <FontAwesomeIcon icon={faFolder} className="text-warning me-2" />
                          <Link to={`/projects/${project.id}`}>{project.name}</Link>
                        </td>
                        <td>{project.description}</td>
                        <td>{project.document_count || 0}</td>
                        <td>{new Date(project.created_at).toLocaleDateString()}</td>
                        <td>
                          <Button
                            as={Link}
                            to={`/projects/edit/${project.id}`}
                            variant="outline-primary"
                            size="sm"
                            className="me-2"
                            title="Edit project"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          {/* <Button
                            variant="outline-warning"
                            size="sm"
                            className="me-2"
                            onClick={() => handleAnalyzeFile(project.id, project.name)}
                            disabled={analyzing}
                            title="Analyze project files"
                          >
                            <FontAwesomeIcon icon={faLightbulb} />
                          </Button> */}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteClick(project)}
                            title="Delete project"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the project "{projectToDelete?.name}"?
          This will also delete all documents associated with this project.
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={handleDeleteConfirm}
            disabled={deleteLoading}
          >
            {deleteLoading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                Deleting...
              </>
            ) : 'Delete Project'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ProjectsList;
